const selectors = ({ store }) => ({
    getContactsPreferences: state => state[store].preferences.contacts,
    getTaxonomyPreference: state => state[store].preferences.contacts.taxonomy,
    getInstagramCheckboxValues: state => state[store].preferences.integrations.instagram,
})

export default selectors
